import PropTypes from 'prop-types';
import React from 'react';

const Link = ({text, href, external, classNames, offScreenText, suffix, jumplink, nodeIndex}) => {
  const linkAttribs = {};

  if (href) {
    linkAttribs.href = href;

    if (href.slice(-4) === '.pdf') {
      suffix = '(PDF)';
    } else if (href.slice(0, 4) === 'tel:') {
      linkAttribs['aria-label'] = href
        .slice(4)
        .replace(/-/g, '.')
        .replace(/(.)(?=.)/g, '$1 ');
    }
  }

  if (external) {
    linkAttribs.target = '_blank';
  }

  if (classNames) {
    linkAttribs.className = classNames;
  }

  if (jumplink) {
    linkAttribs.className = `${classNames || ''} ${jumplink ? 'jumplink' : ''}`
  }

  if (suffix) {
    linkAttribs['aria-labelledby'] = `${nodeIndex}-link-suffix`;
  }

  return (
    <React.Fragment key={nodeIndex}>
      <a href={href} {...linkAttribs}>
        {text}
        {offScreenText ? <span className="sr-only">{offScreenText}</span> : null}
      </a>
      {suffix ? <span id={`${nodeIndex}-link-suffix`}> {suffix}</span> : null}
    </React.Fragment>
  );
};

Link.propTypes = {
  text: PropTypes.string.isRequired,
  href: PropTypes.string.isRequired,
  external: PropTypes.bool,
  classNames: PropTypes.string,
  offScreenText: PropTypes.string,
  suffix: PropTypes.string,
  nodeIndex: PropTypes.oneOfType([PropTypes.number, PropTypes.string])
};

export default Link;



// WEBPACK FOOTER //
// ./node_modules/@hpcare/component-wait-times/node_modules/@hppl/component-link/index.jsx